<template>
	<Head title="Forgot Password" />

	<jet-authentication-card>
		<template #logo>
			<!-- <jet-authentication-card-logo /> -->
		</template>

		<div class="mb-4 text-sm text-gray-600">
			Haben Sie Ihre passwort vergessen? Kein Problem!. <br />
			Teilen Sie uns einfach Ihre E-Mail-Adresse mit und wir senden Ihnen per
			E-Mail einen Link zum Zurücksetzen des Passworts, über den Sie ein Neues
			auswählen können.
		</div>

		<div v-if="status" class="mb-4 text-sm font-medium text-green-600">
			{{ status }}
		</div>

		<jet-validation-errors class="mb-4" />

		<form @submit.prevent="submit">
			<div>
				<jet-label for="email" value="Email" />
				<jet-input
					id="email"
					type="email"
					class="mt-1 block w-full"
					v-model="form.email"
					required
					autofocus
				/>
			</div>

			<div class="mt-4 flex items-center justify-end">
				<jet-button
					:class="{ 'opacity-25': form.processing }"
					:disabled="form.processing"
				>
					Link zum Zurücksetzen des Passwortes zusenden
				</jet-button>
			</div>
		</form>
	</jet-authentication-card>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetValidationErrors from "@/Jetstream/ValidationErrors.vue";

export default {
	components: {
		Head,
		JetAuthenticationCard,
		JetAuthenticationCardLogo,
		JetButton,
		JetInput,
		JetLabel,
		JetValidationErrors,
	},

	props: {
		status: String,
	},

	data() {
		return {
			form: this.$inertia.form({
				email: "",
			}),
		};
	},

	methods: {
		submit() {
			this.form.post(this.route("password.email"));
		},
	},
};
</script>
